/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import DobbiesProductAddToCart from './components/add-product-to-cart';
import { IDobbiesAddProductToCartViewProps } from './dobbies-add-product-to-cart';

export default (props: IDobbiesAddProductToCartViewProps) => {
    return (
        /* VSI-Customization -- START Pass props to custom component  */
        <DobbiesProductAddToCart props={props} />
        /* VSI-Customization -- END  */
    );
};
